import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';
import Modal from '../modules/Modal';

export default trigger => {
    const onClick = e => {
        // If user is holding Cmd (macOS) or Ctrl (Windows/Linux), let the default action happen
        if (e.metaKey || e.ctrlKey) {
            return; // Do not prevent default or run custom logic
        }

        e.preventDefault();

        const modalId = trigger.getAttribute('aria-controls');
        const modal = document.getElementById(modalId);

        if (!modal) {
            console.warn(`No modal with the ID ${modalId} found.`);
            return;
        }

        Modal(modal);
    };

    const onKeyDown = e => {
        if (['Enter', ' '].indexOf(e.key || '') === -1) {
            return;
        }
        e.preventDefault();
        onClick(e);
    };

    const init = () => {
        trigger.addEventListener('click', onClick);

        if (trigger.tagName !== 'BUTTON') {
            trigger.addEventListener('keydown', onKeyDown);
        }

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        trigger.removeEventListener('click', onClick);

        if (trigger.tagName !== 'BUTTON') {
            trigger.removeEventListener('keydown', onKeyDown);
        }
    };

    return {
        init,
        destroy
    };

};
